import { jsx } from "react/jsx-runtime";
import FSBOPropertySearch from "./FSBOPropertySearch.esm.js";
const FSBOPropertySearchBlock = {
  Component: ({
    attrs
  }) => {
    const {
      id
    } = attrs;
    return /* @__PURE__ */ jsx(FSBOPropertySearch, { ...{
      id
    } });
  },
  metadata: {
    version: "1.0",
    name: "constellation/fsbo-search",
    title: "FSBO Search Component",
    description: "Address search for listing a home For Sale By Owner (FSBO).",
    icon: "search",
    keywords: ["fsbo", "search"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Search",
    attributes: {
      id: {
        type: "string"
      }
    }
  }
};
export {
  FSBOPropertySearchBlock as default
};
